import { render, staticRenderFns } from "./BoardModal.vue?vue&type=template&id=627bd745"
import script from "./BoardModal.ts?vue&type=script&lang=ts&external"
export * from "./BoardModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports